import SdaWaitingReport from './SdaWaitingReport';

export default SdaWaitingReport;
